import { formatDate } from 'lib/dateDisplay';
import { getAllCommitsData } from 'lib/documentHandling';
import { Menu, Popover } from 'material-ui';
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import { object } from 'prop-types';
import { path } from 'ramda';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  headerBar,
  headerRow,
  messageMenuComponent,
  messages,
  messageTextArea,
  messageDate,
  messageText,
} from './AnswerArea.less';

const AnswerArea = ({ doc }) => {
  const [showMessagesAnchor, setShowMessagesAnchor] = React.useState(null);
  const [showMessagesOpen, setShowMessagesOpen] = React.useState(false);

  const openMessages = event => {
    event.preventDefault();
    setShowMessagesAnchor(event.currentTarget);
    setShowMessagesOpen(true);
  };
  const closeMessages = () => {
    setShowMessagesAnchor(null);
    setShowMessagesOpen(false);
  };

  const data = getAllCommitsData(doc);

  const firstCommit =
    doc.commits && doc.commits.reverse().find(c => path(['data', 'rehab4', 'answerFromNeurologist'], c));
  const firstDate = firstCommit && firstCommit.commitDate;
  const firstAnswer = path(['rehab4', 'answerFromNeurologist'], data);

  const secondCommit =
    doc.commits && doc.commits.reverse().find(c => path(['data', 'rehab6', 'answerFromNeurologist'], c));
  const secondDate = secondCommit && secondCommit.commitDate;
  const secondAnswer = path(['rehab6', 'answerFromNeurologist'], data);

  return (
    <div>
      <div
        className={headerBar}
        onClick={openMessages}
        style={showMessagesOpen ? { borderBottomLeftRadius: 0, borderBottomRightRadius: 0 } : {}}
      >
        <div className={headerRow}>
          <div style={{ flex: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'start' }}>
              <FormattedMessage
                id="onlineRehabilitation.messages"
                values={{ number: firstAnswer && secondAnswer ? 2 : firstAnswer || secondAnswer ? 1 : 0 }}
              />
            </div>
          </div>
          <div style={{ flex: 4 }}>
            <div style={{ display: 'flex', justifyContent: 'end' }}>
              <ArrowDropDown style={{ display: 'block', padding: 0, margin: 0, color: '#fff', viewBox: '0 0 20 20' }} />
            </div>
          </div>
        </div>
      </div>
      <Popover
        className={messages}
        open={showMessagesOpen}
        anchorEl={showMessagesAnchor}
        onRequestClose={closeMessages}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'left', vertical: 'top' }}
      >
        <Menu className={messageMenuComponent} style={{ maxWidth: '100%', padding: 0 }}>
          {firstAnswer && (
            <div className={messageTextArea}>
              <div className={messageDate}>{formatDate(firstDate) || ''}</div>
              <div className={messageText}>{firstAnswer}</div>
            </div>
          )}
          {secondAnswer && (
            <div className={messageTextArea}>
              <div className={messageDate}>{formatDate(secondDate) || ''}</div>
              <div className={messageText}>{secondAnswer}</div>
            </div>
          )}
          {!firstAnswer && !secondAnswer && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FormattedMessage id="onlineRehabilitation.noMessages" />
            </div>
          )}
        </Menu>
      </Popover>
    </div>
  );
};

AnswerArea.propTypes = {
  doc: object,
};

export default AnswerArea;
